<template>
  <el-link
      v-bind="$attrs"
      v-on="$listeners"
      :href="href"
      :type="type"
      :underline="underline"
      class="gj-link">
    <router-link
        v-if="routeTo"
        :to="routeTo"
        :tag="routerTag">
      <slot></slot>
    </router-link>
    <template v-else>
      <slot></slot>
    </template>
  </el-link>
</template>

<script>
  export default {
    name: "gj-link",
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      underline: {
        type: Boolean,
        default: false
      },
      href: {
        type: String
      },
      routeTo: {
        required: false
      },
      routerTag: {
        default: 'span'
      }
    }
  }
</script>

<style scoped>
  .gj-link {
    vertical-align: unset;
    font-size: 12px;
  }
  /deep/ .el-link--inner {
    display: inline-flex;
  }
</style>
